import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { MenuPage } from './pages/MenuPage';
import { PoolPage } from './pages/PoolPage';
import { ReservationsPage } from './pages/ReservationsPage';
import { GalleryPage } from './pages/GalleryPage';
import { ContactPage } from './pages/ContactPage';
import { AnimatePresence } from 'framer-motion';
export function App() {
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <div className="min-h-screen bg-warmWhite selection:bg-sand selection:text-navy flex flex-col" data-id="element-3">
          <Navbar data-id="element-4" />
          <main className="flex-grow" data-id="element-5">
            <AnimatePresence mode="wait" data-id="element-6">
              <Routes data-id="element-7">
                <Route path="/" element={<HomePage data-id="element-9" />} data-id="element-8" />
                <Route path="/about" element={<AboutPage data-id="element-11" />} data-id="element-10" />
                <Route path="/menu" element={<MenuPage data-id="element-13" />} data-id="element-12" />
                <Route path="/pool" element={<PoolPage data-id="element-15" />} data-id="element-14" />
                <Route path="/reservations" element={<ReservationsPage data-id="element-17" />} data-id="element-16" />
                <Route path="/gallery" element={<GalleryPage data-id="element-19" />} data-id="element-18" />
                <Route path="/contact" element={<ContactPage data-id="element-21" />} data-id="element-20" />
              </Routes>
            </AnimatePresence>
          </main>
          <Footer data-id="element-22" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}